export default __webpack_public_path__ + "static/media/presentationBestStartups.b20279ea.png";